import React from "react";
import { BOOK_FLIGHT_LIST } from "../common/Helper";
import Title from "../common/Title";
import PrimaryBtn from "../common/PrimaryBtn";

const BookFlights = () => {
  return (
    <div className="2xl:max-w-[1200px] mx-auto px-5 pt-[98px] pb-[100px] max-lg:py-20 max-md:py-16">
      <div className=" max-w-[1140px] w-full  mx-auto flex max-sm:flex-col  justify-between items-center gap-6 pb-[57.5px] max-lg:pb-10">
        <Title
          text={"Where will you go next?"}
          myClass={"max-sm:!text-[31px] "}
        />

        <div className="flex justify-center">
          <PrimaryBtn
            text={"See all"}
            myClass={
              "!py-3 w-[114px] whitespace-nowrap !shadow-[0_8px_20px_0_rgba(239,40,83,0.30)]"
            }
          />
        </div>
      </div>
      <div className="flex flex-wrap gap-6 max-lg:gap-4 justify-center">
        {BOOK_FLIGHT_LIST.map((item, index) => (
          <div
            key={index}
            className="rounded-xl h-[420px] w-[364px] max-xl:w-[312px] max-lg:w-[356px] max-lg:h-[380px] max-md:w-[340px] bg-cover bg-center text-white flex flex-col p-[18px]"
            style={{
              backgroundImage: `url(${item.backgroundImage})`,
            }}
          >
            <div className="flex items-center justify-between pt-[267px] max-xl:pt-[265px] max-lg:pt-[222px] max-md:pt-[220px]">
              <div>
                <h2 className="text-2xl max-md:text-xl font-semibold leading-[100%]">
                  {item.place}
                </h2>
                <p className="ff-sans text-base font-normal leading-[150%]">
                  {item.island}
                </p>
              </div>
              <div>
                <span className="font-semibold text-2xl max-md:text-xl leading-[100%]">
                  ${item.prize}
                </span>
              </div>
            </div>
            <PrimaryBtn
              text="Book Flight"
              myClass={
                "!text-black !py-3 w-full !bg-white border-white hover:border-[#FF5858] mt-4"
              }
              spanClass="!text-[#010101] group-hover:text-white"
              secondSpanClass="!bg-[#FF5858] border-white"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BookFlights;
